<template>
	<div class="anonymous-layout h-full w-full">
		<!-- Clean, minimal layout for anonymous pages like signup/reset password -->
		<slot />
	</div>
</template>

<script setup lang="ts">
	// No imports needed - this is intentionally minimal
</script>

<style scoped>
	.anonymous-layout {
		/* Ensure the layout takes full viewport */
		min-height: 100vh;
		background-color: var(--ion-background-color, #ffffff);
	}
</style>
